import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, split } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { getMainDefinition } from 'apollo-utilities';
import { getLocalStorageItem } from './common';
import { getEnv } from './utils';
import WebSocketLink from './WebSocketLink';

const { API_URL } = getEnv();
const API_SUBSCRIPTIONS_URL=location.hostname;

// Widget session token. Held ONLY in memory, never in localStorage. The HttpOnly cookie
// is the primary transport (sent via credentials: "include"); this header is the
// in-memory fallback for when third-party cookies are blocked.
let widgetSessionToken: string | undefined;
export const setWidgetSessionToken = (token?: string) => {
  widgetSessionToken = token || undefined;
};

const sessionLink = new ApolloLink((operation, forward) => {
  if (widgetSessionToken) {
    operation.setContext(({ headers = {} }: any) => ({
      headers: { ...headers, 'erxes-widget-session': widgetSessionToken },
    }));
  }
  return forward(operation);
});

// Create an http link:
const httpLink = createHttpLink({
  uri: `${API_URL}/graphql`,
  credentials: "include",
});

// Subscription config
export const wsLink = new WebSocketLink({
  url: `wss://${location.hostname}/dashboard/api/graphql`,
  lazyCloseTimeout: 30000,
  retryAttempts: 100,
  retryWait: () => new Promise(resolve => setTimeout(resolve, 1000)),
  connectionParams: () => {
    const params:any = {};
    params.messengerDataJson = getLocalStorageItem('messengerDataJson');
    // In-memory fallback so the realtime ownership guard can attribute this socket to
    // the widget session even when third-party cookies are blocked on the WS handshake.
    if (widgetSessionToken) {
      params['erxes-widget-session'] = widgetSessionToken;
    }
    return params;
  },
});

type Definintion = {
  kind: string;
  operation?: string;
};

// Setting up subscription with link
const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation }: Definintion = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  sessionLink.concat(httpLink)
);

// Creating Apollo-client
const client = new ApolloClient({
  link,
  cache: new InMemoryCache()
});

export default client;
